<template>
  <table class="paste-diet-modal__comparison">
    <thead>
      <tr>
        <th />
        <th>Bieżący jadłospis</th>
        <th>Wklejany jadłospis</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in rows" :key="row.label">
        <th scope="row">{{ row.label }}</th>
        <td>{{ row.current }}</td>
        <td>
          <span>{{ row.copied }}</span>
          <Tooltip v-if="row.copied < row.current" placement="right">
            <template #trigger>
              <button
                :aria-label="row.warningLabel"
                class="paste-diet-modal__status paste-diet-modal__status--warning"
                :data-test-id="row.testId"
                type="button"
              >
                <Icon name="AlertTriangle" :size="18" />
              </button>
            </template>
            {{ row.warning }}
          </Tooltip>
          <span
            v-else
            :aria-label="row.successLabel"
            class="paste-diet-modal__status paste-diet-modal__status--success"
          >
            <Icon name="CheckCircle" :size="18" />
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'

  import { Icon, Tooltip } from '@/components/ui'

  const props = defineProps<{
    copiedDaysCount: number
    copiedMealsCount: number
    currentDaysCount: number
    currentMealsCount: number
  }>()
  const rows = computed(() => [
    {
      copied: props.copiedDaysCount,
      current: props.currentDaysCount,
      label: 'Liczba dni',
      successLabel: 'Wklejany jadłospis ma co najmniej tyle samo dni',
      testId: 'PasteDietModal__DaysWarning',
      warning: 'Nadmiarowa liczba dni bieżącego jadłospisu zostanie usunięta.',
      warningLabel: 'Ostrzeżenie dotyczące liczby dni',
    },
    {
      copied: props.copiedMealsCount,
      current: props.currentMealsCount,
      label: 'Liczba posiłków',
      successLabel: 'Wklejany jadłospis ma co najmniej tyle samo posiłków',
      testId: 'PasteDietModal__MealsWarning',
      warning: 'Nadmiarowa liczba posiłków bieżącego jadłospisu zostanie usunięta.',
      warningLabel: 'Ostrzeżenie dotyczące liczby posiłków',
    },
  ])
</script>

<style scoped lang="scss">
@use "@repo/ui/typography.scss" as typography;

.comparison {
  width: 100%;
  margin-bottom: 20px;
  color: var(--color-text-text-secondary-700);
  table-layout: fixed;
  border-collapse: collapse;
}

.comparison th,
.comparison td {
  @include typography.font-style("text-sm", "regular");

  padding: 8px 0;
  text-align: center;
}

.comparison thead th {
  padding-bottom: 16px;
  font-weight: 500;
}

.comparison th:first-child {
  width: 35%;
  text-align: left;
}

.comparison td:last-child {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.status {
  display: inline-flex;
  flex: none;
  align-items: center;
}

button.status {
  padding: 0;
  cursor: help;
  background: transparent;
  border: 0;
}

.paste-diet-modal__status--warning {
  color: var(--color-foreground-fg-warning-primary);
}

.paste-diet-modal__status--success {
  color: var(--color-foreground-fg-success-primary);
}
</style>
